import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Same Firebase project (denzo-b9bd3) already used by denzo-web-app and by
// the backend's Kreait Firebase Admin SDK for phone-OTP verification — these
// are public client identifiers, not secrets, so reusing them here is safe.
const firebaseConfig = {
  apiKey: "AIzaSyDuGjjBKN3d3TcS8z-nch0RTpBV0w3zg9E",
  authDomain: "denzo-b9bd3.firebaseapp.com",
  projectId: "denzo-b9bd3",
  storageBucket: "denzo-b9bd3.appspot.com",
  messagingSenderId: "315632654229",
  appId: "1:315632654229:web:35a2e0b0ce1fc2ac38089c",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
